import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const WilhelmReussStandardSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const WilhelmReussStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}